import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { getCurrentPathnameFromState } from '../../../lib/RouteUtils';
import * as Utils from '../../../utils';

interface IScrollToTopProps {
  pathname: string;
}

function ScrollToTop({ pathname }: IScrollToTopProps): null {
  React.useEffect(() => {
    Utils.Scroll.scrollToTop();
  }, [pathname]);

  return null;
}

ScrollToTop.propTypes = {
  pathname: PropTypes.string,
};

export function mapStateToProps(state: unknown): IScrollToTopProps {
  const pathname = getCurrentPathnameFromState(
    state as Parameters<typeof getCurrentPathnameFromState>,
  );

  return {
    pathname,
  };
}

export default connect(mapStateToProps)(ScrollToTop);
